import React from 'react';
import { RightOutlined } from '@ant-design/icons';

/**
 * UIListItem - List Item organism component
 */
const UIListItem = ({
    title = 'List Item Title',
    subtitle = 'Subtitle or description text',
    image = null,
    action = null,
    variant = 'default',
    state = 'default',
    deviceType = 'mobile',
    tokens
}) => {
    const primaryColor = tokens?.colors?.find(c => c.name === 'primary')?.value || '#1677ff';

    // Get typography from tokens
    const headingTypo = tokens?.typography?.find(t => t.name === 'heading')
        || tokens?.typography?.find(t => t.name === 'body')
        || { fontFamily: 'Inter, system-ui, sans-serif', weight: 500, sizes: { mobile: 14, tablet: 14, desktop: 14 } };
    const bodyTypo = tokens?.typography?.find(t => t.name === 'body')
        || { fontFamily: 'Inter, system-ui, sans-serif', weight: 400, sizes: { mobile: 14, tablet: 14, desktop: 14 } };

    const titleSize = headingTypo.sizes?.[deviceType] || headingTypo.sizes?.mobile || 14;
    const subtitleSize = (bodyTypo.sizes?.[deviceType] || bodyTypo.sizes?.mobile || 14) - 2;
    const baseFontFamily = bodyTypo.fontFamily || 'Inter, system-ui, sans-serif';

    // Loading state
    if (state === 'loading') {
        return (
            <div style={{
                width: '100%',
                height: '100%',
                background: '#21262d',
                borderRadius: 8,
                padding: 16,
                display: 'flex',
                alignItems: 'center',
                gap: 12
            }}>
                {/* Skeleton image */}
                <div style={{
                    width: 48,
                    height: 48,
                    background: '#30363d',
                    borderRadius: 8,
                    animation: 'pulse 1.5s infinite'
                }} />
                {/* Skeleton text */}
                <div style={{ flex: 1 }}>
                    <div style={{
                        width: '60%',
                        height: 14,
                        background: '#30363d',
                        borderRadius: 4,
                        marginBottom: 8
                    }} />
                    <div style={{
                        width: '40%',
                        height: 10,
                        background: '#30363d',
                        borderRadius: 4
                    }} />
                </div>
            </div>
        );
    }

    // Empty state
    if (state === 'empty') {
        return (
            <div style={{
                width: '100%',
                height: '100%',
                background: '#21262d',
                borderRadius: 8,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#8b949e',
                fontSize: subtitleSize,
                fontFamily: baseFontFamily
            }}>
                No items to display
            </div>
        );
    }

    const showImage = variant === 'with-image' || image;
    const showAction = (variant && variant.includes('action')) || action;

    return (
        <div style={{
            width: '100%',
            height: '100%',
            background: '#21262d',
            borderRadius: 8,
            padding: 12,
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            fontFamily: baseFontFamily
        }}>
            {/* Image */}
            {showImage && (
                <div style={{
                    width: 48,
                    height: 48,
                    background: '#30363d',
                    borderRadius: 8,
                    flexShrink: 0
                }} />
            )}

            {/* Content */}
            <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{
                    fontSize: titleSize,
                    fontWeight: headingTypo.weight || 500,
                    fontFamily: headingTypo.fontFamily || baseFontFamily,
                    color: '#c9d1d9',
                    marginBottom: 4,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }}>
                    {title}
                </div>
                <div style={{
                    fontSize: subtitleSize,
                    fontWeight: bodyTypo.weight || 400,
                    color: '#8b949e',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }}>
                    {subtitle}
                </div>
            </div>

            {/* Action */}
            {showAction && (
                <RightOutlined style={{
                    color: '#8b949e',
                    fontSize: 12
                }} />
            )}
        </div>
    );
};

export default UIListItem;
